import FreelancerCategory from ".";

export const freelancerCategoryRoutes = () => [
  {
    path: "/admin/freelancer-categories",
    component: FreelancerCategory,
    layout: "admin",
    routeType: "admin",
    title: "Freelancers Management",
  },
];
